
<template>
  <amplify-authenticator>
    <div id="app">
      <img alt="Cluster" src="./assets/logo.svg">
      <amplify-sign-out></amplify-sign-out>
    </div>
  </amplify-authenticator>
</template>


<script>
  export default {
    name: "app",
    components: {},
    data() {
      return {
        authConfig: {
          hideAllDefaults: false,
          signUpConfig: {
            hiddenDefaults: ["phone_number"]
          }
        }
      };
    }
  }

// import HelloWorld from './components/HelloWorld.vue'

// export default {
//   name: 'App',
//   components: {
//     HelloWorld
//   }
// }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
